import { render, staticRenderFns } from "./BlankSpace.vue?vue&type=template&id=f258f88a&scoped=true"
import script from "./BlankSpace.vue?vue&type=script&lang=ts"
export * from "./BlankSpace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f258f88a",
  null
  
)

export default component.exports